import React from 'react';
import PictureHeader from '../PictureHeader';
import KeyValueInputGroup from '../../../../components/forms/KeyValueInputGroup';
import Input from '../../../../components/forms/Input';
import TextArea from '../../../../components/forms/TextArea';
import { socialMediaOptions } from '../../../../selectors/admin/models/contacts';
import SelectField from '../../../../components/forms/SelectField';
import { eventsFromOrganizations } from '../../../../selectors/events/events';
import TagsSelector from '../TagsSelector';

const ArtistInputs = props => (
    <React.Fragment>
        <PictureHeader
            data={props.data}
            errors={props.errors}
            nameLabel={'Artist Group Name *'}
            onInput={props.onInput}
        />
        <div className="ckp-admin-forms-body">
            <div className="ckp-admin-grid-row">
                <div className="ckp-admin-grid-column is-1-3">
                    <SelectField
                        disabled={props.withContext}
                        items={props.contextOptions}
                        label="Organizations"
                        onChange={props.onInput}
                        name="organizationIds"
                        multiple={true}
                        value={props.withContext ? [props.context] : props.data.organizationIds}
                    />
                    <SelectField
                        disabled={props.withContext ? false : !props.data.organizationIds.length}
                        items={eventsFromOrganizations(
                            props.withContext,
                            props.context,
                            props.data.organizationIds,
                            props.dependencies.events
                        )}
                        label="Events"
                        onChange={props.onInput}
                        name="eventIds"
                        multiple={true}
                        value={props.data.eventIds}
                    />
                    <KeyValueInputGroup
                        name="socialMedia"
                        keyLabel="Social Media"
                        valueLabel="URL"
                        onKeyValueInput={props.onKeyValueInput}
                        options={socialMediaOptions}
                        group={props.data.socialMedia}
                        onDelete={props.onKeyValueDelete}
                    />
                    <Input
                        className="is-full-width"
                        errorMessage={props.errors.website}
                        label="Website"
                        name="website"
                        onChange={props.onInput}
                        value={props.data.website}
                    />
                    <TagsSelector value={props.data.tags} name="tags" onChange={props.onInput} />
                </div>
                <div className="ckp-admin-grid-column is-2-3">
                    <TextArea label="Note" name="note" onChange={props.onInput} value={props.data.note} />
                </div>
            </div>
        </div>
    </React.Fragment>
);

export default ArtistInputs;
